// extracted by mini-css-extract-plugin
export default {"loadingBox":"loadingBox-R8gCXw","bar":"bar-WSZEcS","spinners":"spinners-iUIzLL"};